import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./swiper.css";
import { memorialApi } from "../misc/memorial.js";
import { useKeycloak } from "@react-keycloak/web";
import { Autoplay, Pagination } from "swiper";
import { useSummary, useTopN, useUserComment } from "./hooks";

const Comments = ({ messages }) => {
  const { keycloak } = useKeycloak();
  const { mutate: reloadSummary } = useSummary(100);
  const { topN, isLoading, isError, mutateTopN } = useTopN(100);
  const { userComment, isLoading: isCommentLoading } = useUserComment(keycloak);
  const [comment, setComment] = useState("");
  const [success, setSuccess] = useState(false);
  const [touched, setTouched] = useState(false);
  const [tips, setTips] = useState("");
  const commentRef = useRef(null);
  async function handleSubmit(e) {
    e.preventDefault();
    setTouched(true);
    if (!comment) return;
    if (comment.length < 5 || comment.length > 50) {
      setTips("抱歉留言论字数不符合要求（限定5-50字符）");
      return;
    }
    if (!keycloak.authenticated) {
      keycloak.login();
      return;
    }
    if (userComment?.exist) {
      setTips("抱歉，您已经发表过留言了");
      return;
    }
    try {
      const res = await memorialApi.addComment(keycloak?.token, comment);
      if (res) {
        reloadSummary();
        setSuccess(true);
        setTips("发送成功");
        setTimeout(() => {
          setSuccess(false);
          setTips("");
        }, 3000);
        mutateTopN();
      }
    } catch (e) {
      console.log(e);
    }
    setComment("");
  }
  if (isLoading) {
    return <div>loading...</div>;
  }
  return (
    <div className="flex flex-col gap-[56px] md:py-[6px] w-full px-5 md:w-auto">
      <div className="md:w-[752px] overflow-hidden h-[400px]">
        <Swiper
          direction="vertical"
          spaceBetween={10}
          autoplay={{
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Autoplay]}
          speed={2000}
          slidesPerView={6}
          className="swiper-container"
          allowTouchMove={false}
        >
          {topN &&
            topN?.comments.map((message, index) => (
              <SwiperSlide key={index} className="my-slide">
                <div className="flex w-full text-black flex-col text-left">
                  <div className="text-sm text-white">{message?.comment}</div>
                  <div className="text-[#FFFFFF7A] text-sm">
                    {message?.username}
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>

      <div className="relative">
        <form onSubmit={handleSubmit}>
          <div className="flex flex-1 px-4 py-2 rounded focus:outline-none w-full bg-[#000] text-white border border-[#FFFFFF80] transition-all hover:border-[#FFFFFF]">
            <input
              type="text"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
                if (e.target.value.length >= 50) {
                  setTips("");
                }
              }}
              onFocus={() => {
                if (!keycloak.authenticated) {
                  keycloak.login();
                }
              }}
              ref={commentRef}
              placeholder="希望5-50字符足以表达您的追思之情"
              className="flex-1 rounded focus:outline-none w-full bg-[#000] text-white"
            />
            <button
              type="submit"
              className="rounded focus:outline-none bg-[#000] text-white"
              // disabled={
              //   isLoading ||
              //   isError ||
              //   comment.length > 50 ||
              //   comment.length < 5 ||
              //   userComment?.exist
              // }
            >
              <img src="/send.svg" alt="send" width={24} height={24} />
            </button>
          </div>
        </form>
        <p className="mt-4">
          {<span className="text-[#FFFFFF7A]">{touched && tips}</span>}
        </p>
      </div>
    </div>
  );
};

export default Comments;
